import Component from './OrderCard';

export default Component;
